<template>
  <div class="opera-orderList">
    <topNav :title="$t('orderList_title')"></topNav>
    <div class="ordertop" :class='{searchFix:searchPosition}' :style='{top:searchTop}'>
      <div class="search">
        <i class="iconfont icon-sousuo"></i>
        <input type="text" id='seachContent' v-model='searchOption.searchText' name=""      :placeholder="$t('orderList_searchText_placeholder')">
        <div class="cleartext" v-show="searchOption.searchText != ''">
          <i class="iconfont icon-cuowu" @click="searchOption.searchText='';getOrderListNew()"></i>
        </div>
      </div>
      <div class="searchBtn" @click="getOrderListNew">{{$t('search')}}</div>
    </div>
    <div class="oList">
      <div class="tags clearfix" :class='{posiTwo:fixedTwo}' :style='{top:PosiTop}'>
        <div style="width: 3000px">
          <div class="tag" @click="getList(1)" :class="{active:searchOption.index==1}">
            {{$t('orderList_notArr')}}
            ({{stateNum.notArr}})
          </div>
          <div class="tag" @click="getList(23)" :class="{active:searchOption.index==23}">
            {{$t('orderList_hasArr')}}
            ({{stateNum.hasArr}})
          </div>
          <div class="tag" @click="getList(22)" :class="{active:searchOption.index==22}">
            {{$t('orderList_notDep')}}
            ({{stateNum.notDep}})
          </div>
          <div class="tag" @click="getList(24)" :class="{active:searchOption.index==24}">
            {{$t('orderList_hasDep')}}
            ({{stateNum.hasDep}})
          </div>
          <div class="tag" @click="getList(11)" :class="{active:searchOption.index==11}">
            {{$t('orderList_allReserve')}}
            ({{stateNum.allReserve}})
          </div>
        </div>
      </div>

      <ul class="list clearfix" v-infinite-scroll="getNextPage"
          infinite-scroll-disabled="loading" infinite-scroll-distance="20">
        <li class="item" v-for="(order,index) in orderList" :key="index">
          <div class="detailed">
            <div class="top clearfix"><p class="left">{{$t('orderList_rsvNo')}}：{{order.rsvNo}}</p></div>
            <router-link :to="link(order)">
              <div class="content clearfix">
                <ul>
                  <!-- 姓名-->
                  <li class="info">
                    {{$t('orderList_username')}}：{{order.username}}
                  </li>
                  <!-- 手机：-->
                  <li class="info">
                    {{$t('orderList_mobile')}}：{{order.mobile}}
                  </li>
                  <!-- 到离：-->
                  <li class="info">
                    {{$t('orderList_arr')}}：{{order.arr | dateF}}-{{order.dep | dateF}}
                  </li>
                  <!--间数：-->
                  <li class="info">
                    {{$t('orderList_rmnum')}}：{{order.rmnum}}
                  </li>
                  <!--房类：-->
                  <li class="info">
                    {{$t('orderList_rmtype')}}：{{order.rmtype}}
                  </li>
                  <!--房价：-->
                  <li class="info">
                    {{$t('orderList_realRate')}}：
                    <small>￥</small>
                    {{order.realRate}}
                  </li>
                  <!--卡号：-->
                  <li class="info">
                    {{$t('orderList_member_no')}}：{{order.member_no}}
                  </li>
                  <!--公司：-->
                  <li class="info">
                    {{$t('orderList_member_crpName')}}：<span>{{order.crpName}}</span>
                  </li>
                </ul>
                <i class="iconfont icon-you"></i>
              </div>
            </router-link>
          </div>
        </li>
        <li class="loadingli" v-show="loading">
          <mt-spinner :type="2"></mt-spinner>
        </li>
        <nothing :condition="orderList != null && orderList.length == 0"></nothing>
        <li class="dx" v-show="hasDx">
          {{$t('loading_end_message')}}
        </li>
      </ul>

    </div>

  </div>
</template>
<script>
  import _ from "lodash";
  import nothing from "../operaCommon/nothing";
  import {InfiniteScroll} from "mint-ui";

  export default {
    data() {
      return {
        orderList: null,
        searchTop: 0,
        PosiTop: 0,
        totalCount: "",
        scrollTop: '',
        fixPosition: 0,
        downPosition: 37,
        loading: false,
        hasDx: false,
        //   isFixed:false,
        fixedTwo: false,
        //   showzi:false,
        searchPosition: false,
        allTop: 0,
        preScroll: '',
        searchOption: {
          searchText: "",
          currentPage: 1,
          pageSize: 20,
          index: !!localStorage.orderListTab ? localStorage.orderListTab : 1
        },
        stateNum: {hasArr: 0, hasDep: 0, notArr: 0, notDep: 0, allReserve: 0}
      };
    },
    mounted() {
      this.$http.get("/mobilepmsapi/opera/biz/getOrderListSum").then(res => {
        if (res.data.result == 0) {
          _.forEach(res.data.retVal, (n1, key1) => {
            //console.log(key1+"="+n1);
            this.stateNum[key1] = n1;
            //console.log(this.stateNum)
          });
        }
      });
      this.getOrderList();
      //监听页面的滚动条
      document.getElementsByClassName('opera-orderList')[0].addEventListener('scroll', this.handleScroll);
    },
    methods: {
      /*请求*/
      getOrderListNew() {
        this.orderList = null;
        this.hasDx = false;
        this.getOrderList();
      },
      getOrderList() {
        this.$http
          .post("/mobilepmsapi/opera/biz/getOrderList", this.searchOption)
          .then(res => {
            if (res.data.result == 0) {
              if (this.orderList == null) {
                this.orderList = [];
              }
              _.forEach(res.data.retVal.list, (el, key) => {
                this.orderList.push(el);
              });
              this.totalCount = res.data.retVal.totalCount;
              this.loading = false;
              if (this.orderList.length > 5 && this.totalCount < parseFloat(this.searchOption.pageSize) * parseFloat(this.searchOption.currentPage)) {
                this.hasDx = true;
              }
            }
          });
      },
      //滚动条上拉下滑顶部固定事件
      handleScroll() {
        this.searchPosition = false;
        var pxNumber = document.getElementsByClassName('opera-orderList')[0].scrollTop;
        this.scrollTop = pxNumber / 37.5
        // console.log( this.scrollTop)
        this.PosiTop = 0 + 'rem';
        if (this.scrollTop >= 1.04) {
          if (this.preScroll < this.scrollTop) {
            this.fixPosition = 0;//滚动差清零
            this.searchPosition = false;//搜索条不固定
            this.fixedTwo = true;//tab栏目固定
            this.PosiTop = 1.04 + 'rem';
          }
          if (this.preScroll > this.scrollTop) {
            this.searchPosition = true;
            this.fixedTwo = true;
            this.searchTop = 0 + 'rem';
            this.setPosition()
          }
        } else {
          this.fixedTwo = false
        }
        this.preScroll = this.scrollTop
      },
      //上滑平滑显示搜索条
      setPosition() {
        // console.log('fixPosition'+this.fixPosition)
        if (this.fixPosition + (this.preScroll - this.scrollTop) > 1) {
          this.searchTop = 1.04 + 'rem';
          this.PosiTop = 2.32 + 'rem';
          //console.log('固定')
        } else {
          this.searchTop = this.fixPosition + (this.preScroll - this.scrollTop) + 'rem';
          this.PosiTop = 1.28 + this.fixPosition + (this.preScroll - this.scrollTop) + 'rem';
          //console.log('平滑')
        }
        this.fixPosition = this.fixPosition + (this.preScroll - this.scrollTop)

      },
      //下拉平滑隐藏搜索条
      setPosition() {
        // console.log('fixPosition'+this.fixPosition)
        if (this.fixPosition + (this.preScroll - this.scrollTop) > 1) {
          this.searchTop = 1.04 + 'rem';
          this.PosiTop = 2.32 + 'rem';
          //console.log('固定')
        } else {
          this.searchTop = this.fixPosition + (this.preScroll - this.scrollTop) + 'rem';
          this.PosiTop = 1.28 + this.fixPosition + (this.preScroll - this.scrollTop) + 'rem';
          // console.log('平滑')
        }
        this.fixPosition = this.fixPosition + (this.preScroll - this.scrollTop)

      },

      /*tab切换*/
      getList(index) {
        this.searchOption = {
          searchText: "",
          currentPage: 1,
          pageSize: 20,
          index: "1"
        }; //切换选项时设置默认条件
        this.orderList = null;
        this.hasDx = false;
        this.searchOption.index = index;
        this.getOrderList();
        localStorage.setItem("orderListTab", this.searchOption.index);
      },
      getNextPage() {
        if (this.totalCount >= parseFloat(this.searchOption.pageSize) * parseFloat(this.searchOption.currentPage)) {
          this.searchOption.currentPage += 1;
          this.loading = true;
          let sef = this;
          setTimeout(function () {
            sef.getOrderList();
          }, 50)
        } else {

        }
      },
      link(order) {
        return "/opera/orderDetail?rsvNo=" + order.rsvNo;
      }
    },
    filters: {
      dateF(value) {
        return value != "" ? value.replace(/-/g, "/").substring(5, 10) : "";
      }
    },
    components: {
      nothing
    },
    //去除上移下滑效果的页面的scrollTop监听
    beforeRouteLeave(to, from, next) {
      document.getElementsByClassName('opera-orderList')[0].removeEventListener('scroll', this.handleScroll)
      next();

    },
    watch: {}
  };
</script>
<style lang='less' scoped>
  .opera-orderList {
    background: #f7f8fa;
    overflow: auto;

    .searchFix {
      position: fixed;
      top: 0;
      z-index: 98;
    }

    // .ziindex{
    //         z-index: 3000;
    // }
    .ordertop {
      height: 1.28rem;
      width: 10rem;
      margin-top: -1px;
      background: #fff;
      padding: 0.18666667rem 0;
      box-sizing: border-box;
      top: 37px;
      z-index: 98;
      // position:fixed;
      // top:1.066667rem;
      .search {
        margin-left: 0.34666667rem;
        border-radius: 0.44rem;
        width: 7.92rem;
        float: left;
        height: 0.85333333rem;
        background-color: #f7f8fa;
        padding: 0 0.26666667rem;
        overflow: hidden;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        i.icon-sousuo {
          vertical-align: bottom;
          font-size: 0.42666667rem;
          color: #ccc;
          line-height: 0.89333333rem;
        }

        input {
          padding-left: 0.2rem;
          width: 6rem;
          vertical-align: middle;
          //margin-bottom: 0.13333rem;
          flex: 1;
          height: 0.62666667rem;
          background-color: #f7f8fa;
          outline: 0;
          border: 0;
        }

        .cleartext {
          float: right;
          display: block;

          i.icon-cuowu {
            line-height: 0.32rem;
            background-color: #c3c3c3;
            border-radius: 50%;
            font-size: 0.32rem;
            text-align: center;
            color: #fff;
            padding: 0.13333333rem;
            margin-top: 0.13333333rem;
            -webkit-transform-origin-x: 0;
            transform: scale(0.6);
            -webkit-transform: scale(0.6);
            width: 0.32rem;
            display: inline-block;
          }
        }
      }

      .searchBtn {
        width: 1.73333333rem;
        text-align: center;
        float: left;
        line-height: 0.85333333rem;
        font-size: 0.32rem;
        color: #333333;
      }
    }

    .oList {
      // margin-top: 1.5467rem;
      // margin-top: 5px;
      padding: 0 5px;
      // .posi{
      //     position: fixed;
      //     top: 37px;
      //     z-index: 3000;
      // }
      // .ziindex{
      //     z-index: 3000;
      // }
      .posiTwo {
        position: fixed;
        top: 0;
        z-index: 98;
      }

      .tags {
        background-color: #fff;
        height: 0.9067rem;
        width: 100%;
        overflow-x: auto;
        overflow-y: hidden;
        //   margin-top: -5px;
        margin-top: -1px;
        border-bottom: 3px solid #f7f8fa;
        border-top: 5px solid #f7f8fa;

        &::-webkit-scrollbar {
          width: 0px;
          height: 0px;
        }

        .tag {
          float: left;
          position: relative;
          /*width: 70px;*/
          height: 0.9067rem;
          text-align: center;
          line-height: 34px;
          font-size: 12px;
          color: #333;
          padding: 0 10px;

          &.active:after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            width: 30px;
            height: 3px;
            background-color: #f69c2d;
            margin: 0 auto;
          }
        }
      }

      .list {
        height: ~"calc(100vh - 132px)";
        //   overflow: auto;
        width: 100%;
        z-index: 30;

        .item {
          &:first-child {
            margin-top: -0.2667rem;
          }

          .detailed {
            width: 100%;
            margin: 12px auto 0;
            line-height: 14px;
            font-size: 12px;
            background-color: #fff;

            .top {
              padding: 6px 8px;
              border-bottom: 1px dashed #ddd;
              border-top: 3px solid #d2d6de;

              .left {
                float: left;
              }

              p {
                padding-right: 20px;
                line-height: 16px;
              }

              .right {
                float: right;

                span {
                  color: #d0011b;
                }
              }
            }

            .content {
              position: relative;

              .info {
                color: #333;
                float: left;
                box-sizing: border-box;
                height: 22px;
                line-height: 22px;
                font-size: 12px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;

                span {
                  width: 3.2rem;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
              }

              .info:nth-of-type(2n-1) {
                width: 45%;
                padding-left: 13px;
              }

              .info:nth-of-type(2n) {
                width: 55%;
              }

              .iconfont {
                position: absolute;
                right: 6px;
                top: ~"calc(50% - 6px)";
                color: #9b9b9b;
              }
            }
          }
        }

        .loadingli {
          text-align: center;
          height: 40px;
          line-height: 40px;
        }

        .dx {
          text-align: center;
          height: 20px;
          margin-top: 20px;
          line-height: 20px;
          color: #ccc;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// orderList.vue?6cb1c60d